<template>
    <div class="get-started-modal">
        <div class="get-started-images" style="background-image: url(assets/img/istockphoto-669695312-2048x2048.jpg)">
            &nbsp;
        </div>

        <div class="get-started-form">
            <h1>Great, we’re excited to get started as well!</h1>
            <span class="description">The first thing I would like to do is set up your access to our program.</span>
            <v-form v-model="valid" ref="form">
                <div class="row">
                    <div class="col">
                        <v-text-field label="Your first name" v-model="fname" :rules="fnameRules"></v-text-field>
                    </div>
                    <div class="col">
                        <v-text-field label="Your last name" v-model="lname" :rules="lnameRules"></v-text-field>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <v-text-field label="Your email" v-model="email" :rules="emailRules"></v-text-field>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <v-text-field :type="'password'" label="Your password" v-model="password" :rules="passwordRules"></v-text-field>
                    </div>
                    <div class="col">
                        <v-text-field :type="'password'" label="Confirm password" v-model="password_confirmation" :rules="passwordConfirmationRules"></v-text-field>
                    </div>
                </div>
                    <v-alert dense
                             outlined
                             type="error"
                             v-if="errors.length > 0">
                        <p>We were not able to register your account.</p>
                        <p>Please correct the following errors and try again:</p>
                        <ul>
                            <li v-for="error in errors" :key="error">{{ error }}</li>
                        </ul>
                    </v-alert>
                <div class="row">
                    <div class="col">
                        <v-btn color="primary" v-if="!isLoading" depressed @click="register">Get started now!</v-btn>
                        <v-container v-else id="loading-container">
                            <v-layout row justify-center align-center>
                                <v-progress-circular
                                        indeterminate
                                        color="primary"
                                ></v-progress-circular>
                            </v-layout>
                        </v-container>
                    </div>
                </div>
            </v-form>
        </div>
    </div>
</template>

<script>
    export default {
        name: "GetStartedModal",
        data() {
            return {
                isLoading: false,
                valid: false,
                errors: [],
                fname: '',
                lname: '',
                email: '',
                password: '',
                password_confirmation: '',
                fnameRules: [
                    v => !!v || 'First Name is required',
                ],
                lnameRules: [
                    v => !!v || 'Last Name is required',
                ],
                passwordRules: [
                    v => !!v || 'Password is required',
                    v => v && v.length >= 6 || 'The password must be at least 6 characters',
                ],
                emailRules: [
                    v => !!v || 'E-mail is required',
                    v => /.+@.+/.test(v) || 'E-mail must be valid',
                ],
            }
        },
        methods: {
            register() {
                this.$refs.form.validate();

                if (! this.valid || this.isLoading) {
                    return;
                }

                this.errors = [];
                this.isLoading = true;

                this.$store
                    .dispatch('auth/register', {
                        fname: this.fname,
                        lname: this.lname,
                        email: this.email,
                        password: this.password,
                        password_confirmation: this.password_confirmation,
                    })
                    .then(() => {
                        this.$router.push({ name: 'GetStarted' });
                        this.$modal.hide('GetStartedModal');
                    })
                    .catch(error => this.errors = Object.values(error.response.data.errors).flat())
                    .then(() => this.isLoading = false);
            }
        },
        computed: {
            passwordConfirmationRules() {
                return [
                    v => !!v || 'Password confirmation is required',
                    (this.password === this.password_confirmation) || 'Passwords must match',
                    v => v && v.length >= 6 || 'The password must be at least 6 characters',
                ]
            },
        }
    }
</script>

<style scoped>
    .theme--light.v-btn:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
        background-color: #1d5be5 !important;
    }
    #loading-container {
        width: 30px;
    }
</style>
